import React, { useState, useEffect } from "react";
import axios from "axios";
import "./style.css";
import { useSelector } from "react-redux";
import YogaPostCard from "./YogaPostCard";
import CreateYogaPost from "./CreateYogaPost";
import YogaFilters from "./YogaFilters";

export default function YogaFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [showCreatePost, setShowCreatePost] = useState(false);
  
  // Filtros
  const [filters, setFilters] = useState({
    sortBy: "newest",
    postType: "",
    level: "",
    yogaStyle: "",
    focus: "",
    minDuration: "",
    maxDuration: ""
  });

  useEffect(() => {
    fetchYogaFeed();
    // eslint-disable-next-line
  }, [page, filters]);

  const fetchYogaFeed = async () => {
    try {
      setLoading(true);
      
      // Construir query string
      let queryParams = `page=${page}&limit=12`;
      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          queryParams += `&${key}=${filters[key]}`;
        }
      });

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/yoga/feed?${queryParams}`,
        {
          headers: {
            Authorization: `Bearer ${user.token || localStorage.getItem("token")}`
          }
        }
      );

      if (page === 1) {
        setPosts(response.data.data);
      } else {
        setPosts((prevPosts) => [...prevPosts, ...response.data.data]);
      }

      setHasMore(page < response.data.pagination.totalPages);
      setError(null);
    } catch (err) {
      setError("Erro ao carregar feed de yoga");
      console.error("Erro:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleNewPost = (newPost) => {
    setPosts([newPost, ...posts]);
    setShowCreatePost(false);
  };

  const handlePostUpdate = (updatedPost) => {
    setPosts(
      posts.map((post) => (post._id === updatedPost._id ? updatedPost : post))
    );
  };

  const handlePostDelete = (postId) => {
    setPosts(posts.filter((post) => post._id !== postId));
  };

  const handleLoadMore = () => {
    setPage((prevPage) => prevPage + 1);
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setPage(1);
  };

  return (
    <div className="yoga-feed-wrapper">
      <div className="yoga-feed-header-section">
        <div className="yoga-feed-title">
          <h2>🧘 Yoga Feed</h2>
          <p>Pratique yoga, meditação e bem-estar</p>
        </div>
        <button
          className="btn-create-post-yoga"
          onClick={() => setShowCreatePost(true)}
        >
          + Criar Post
        </button>
      </div>

      <YogaFilters 
        filters={filters} 
        onFilterChange={handleFilterChange} 
      />

      {showCreatePost && (
        <CreateYogaPost
          onClose={() => setShowCreatePost(false)}
          onPostCreated={handleNewPost}
        />
      )}

      {error && <div className="error-message-yoga">{error}</div>}

      {loading && page === 1 ? (
        <div className="loading-spinner-yoga">
          <div className="spinner-yoga"></div>
          <p>Carregando práticas de yoga...</p>
        </div>
      ) : posts.length > 0 ? (
        <>
          <div className="posts-grid-yoga">
            {posts.map((post) => (
              <YogaPostCard
                key={post._id}
                post={post}
                onUpdate={handlePostUpdate}
                onDelete={handlePostDelete}
              />
            ))}
          </div>

          {hasMore && (
            <button className="load-more-btn-yoga" onClick={handleLoadMore}>
              {loading ? "Carregando..." : "Carregar mais"}
            </button>
          )}
        </>
      ) : (
        <div className="empty-state-yoga">
          <div className="empty-icon">🧘</div>
          <p>Nenhuma prática de yoga ainda</p>
          <button onClick={() => setShowCreatePost(true)}>
            Seja o primeiro a compartilhar
          </button>
        </div>
      )}
    </div>
  );
}
